import { Ionicons } from '@expo/vector-icons';
import React from 'react';
import { View } from 'react-native';

import { useThemePalette } from '@/config/theme';

import { AppText } from './AppText';
import { Button } from './Button';

export interface EmptyStateProps {
  icon?: keyof typeof Ionicons.glyphMap;
  title: string;
  body?: string;
  actionLabel?: string;
  onAction?: () => void;
  className?: string;
}

export function EmptyState({
  icon = 'football-outline',
  title,
  body,
  actionLabel,
  onAction,
  className,
}: EmptyStateProps) {
  const palette = useThemePalette();
  return (
    <View className={`items-center justify-center px-8 py-12${className ? ` ${className}` : ''}`}>
      <View className="mb-4 h-16 w-16 items-center justify-center rounded-full bg-surface-2">
        <Ionicons name={icon} size={28} color={palette.muted} />
      </View>
      <AppText variant="heading" className="text-center">
        {title}
      </AppText>
      {body ? (
        <AppText variant="caption" className="mt-2 max-w-[280px] text-center leading-5">
          {body}
        </AppText>
      ) : null}
      {actionLabel && onAction ? (
        <Button label={actionLabel} onPress={onAction} compact className="mt-5" />
      ) : null}
    </View>
  );
}
